module.exports = __webpack_public_path__ + "img/car_icon17.826f700c.png";